export * from "./fetch";
import { useMutation } from "../../utils/use-mutation";
import { temporaryAccessTokenCreate, temporaryAccessTokenDisableSelf, temporaryAccessTokenCreateForOrganisation, } from "./fetch";
export const useTemporaryAccessTokenCreate = (params) => {
    return useMutation(temporaryAccessTokenCreate, params);
};
export const useTemporaryAccessTokenDisableSelf = (params) => {
    return useMutation(temporaryAccessTokenDisableSelf, params);
};
export const useTemporaryAccessTokenCreateForOrganisation = (params) => {
    return useMutation(temporaryAccessTokenCreateForOrganisation, params);
};
